<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                [routerLink]="['/request/outofoffice/add/',0]" [disabled]="isDisabled">
                <i class="bi bi-suitcase" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Out of Office Request':'Loading...'}}
            </button>
        </div>
    </div>
</div>

<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        <div class="card-title">
            Out of Office Request History
        </div>
    </div>
    <div class="card-body">
        <form class="g-3" name="filterForm" (ngSubmit)="Validate(filterForm)" #filterForm="ngForm" novalidate>
            <div class="row pb-2">
                <div class="col-md-3">
                    <label for="FromDate" class="text-label-dark">From Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="FromDate"
                            [(ngModel)]="Filter.FromDate" ngbDatepicker #FromDate="ngbDatepicker" readonly required
                            [disabled]="Filter.IsWithdraw" (ngModelChange)="Clear()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                            type="button" [disabled]="Filter.IsWithdraw"></button>
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="ToDate" class="text-label-dark">To Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="ToDate" [(ngModel)]="Filter.ToDate"
                            ngbDatepicker #ToDate="ngbDatepicker" readonly required [disabled]="Filter.IsWithdraw"
                            (ngModelChange)="Clear()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                            type="button" [disabled]="Filter.IsWithdraw"></button>
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="ApprovalStatus" class="form-font-label">Status</label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status"
                        name="Status" data-live-search="true" [(ngModel)]="Filter.ApprovalStatus"
                        #ApprovalStatus="ngModel" required [disabled]="Filter.IsWithdraw"
                        (change)="Clear()">
                        @for (status of common.Status; track status.Value; let i = $index) {
                        <option [value]="status.Value">
                            <div class="row">
                                <div class="col">{{status.Name}}</div>
                            </div>
                        </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select Approval Status!
                    </div>
                </div>
                <div class="col" style="align-content: center;font-weight: 500;font-size: 15px;">
                    <span class="Label" style="margin-left: 3%;">
                        <input type="checkbox" name="admincharg" [(ngModel)]="Filter.IsWithdraw" ngbCheckbox
                            (change)="Clear()" />
                        Withdraw Only
                    </span>
                </div>
                <div class="col-md-auto mt-4">
                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>
        <div>
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th [ngClass]="{'colHide': this.Filter.IsWithdraw}">View</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Withdraw</th>

                        <th style="width: 300px;">{{common.ToLowerCase(user.EmpType) == 'front'?'Client
                            Location':common.ToLowerCase(user.EmpType) == 'back'?'Branch':''}}</th>
                        <th style="width: 100px;">Request Date</th>

                        <!-- <th style="width: 100px;" [ngClass]="{'colHide': !this.Filter.IsWithdraw}">Withdraw Date</th> -->
                        <th style="width: 100px;">Shift Title</th>

                        <th style="width: 100px;">In Time</th>
                        <th style="width: 100px;">Out Time</th>
                        <th>Attachment</th>

                        <th>Reason</th>
                        <!-- <th style="width: 150px;">Remark</th> -->
                        <th [ngClass]="{'colHide': this.Filter.IsWithdraw}">Status</th>

                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of OutOfOfficeLoad; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <div style="width: 80px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                    [routerLink]="['/request/outofoffice/detail/',TableData['ESS_OutOfOfficeAttendanceDetailsID']]"><i
                                        class="bi bi-info-square me-1"></i>View</button></div>
                        </td>
                        <td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <div style="width: 110px;"
                                *ngIf="common.ToLowerCase(TableData['ApprovalStatus']) == 'pending'"><button
                                    type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="SaveWithdrawmDetails(TableData['ESS_OutOfOfficeAttendanceDetailsID'])"><i
                                        class="bi bi-x-circle me-1"></i>Withdraw</button></div>
                        </td>


                        <td style="width: 300px;">
                            <div style="width: 300px;">{{common.ToLowerCase(user.EmpType) ==
                                'front'?TableData['ClientLocation']:common.ToLowerCase(user.EmpType) ==
                                'back'?TableData['BranchName']:''}}</div>
                        </td>
                        <td style="width: 100px;">
                            <div style="width: 100px;">{{TableData['RequestDate'] | date : 'dd MMM yyyy' }}</div>
                        </td>


                        <td style="width: 100px;">{{TableData['ShiftTitle']}}</td>
                        <td style="width: 100px;">
                            <div style="width: 100px;">{{TableData['InTime'] | date : 'dd MMM yyyy HH:mm' }}</div>
                        </td>
                        <td style="width: 100px;">
                            <div style="width: 100px;">{{TableData['OutTime'] | date : 'dd MMM yyyy HH:mm' }}</div>
                        </td>

                        <td>
                            <a [href]="Link(TableData['Attachment'])" target="_blank"
                                *ngIf="(TableData['Attachment'] == '' || TableData['Attachment'] == null)?false:true"><i
                                    class="bi bi-paperclip" style="font-size: 1.5rem;"></i></a>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;">{{TableData['Reason']}}</div>
                        </td>
                        <!-- <td style="width: 150px;">
                            <div style="width: 150px;">{{TableData['Remark']}}</div>
                        </td> -->
                        <td [ngClass]="{'colHide': this.Filter.IsWithdraw}"><span class="badge"
                                [ngClass]="{'success':common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'warning':common.ToLowerCase(TableData['ApprovalStatus']) == 'pending','danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected'}">{{TableData['ApprovalStatus']}}</span>
                        </td>

                    </tr>
                </tbody>
            </table>

        </div>

    </div>
</div>